import axios from "axios";
import queryString from "query-string";

export default function shareRecipe({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({
    recipeID,
    value,
    final_image,
    userChoiceValuesForUI,
    expectedDelivery,
    cost,
    selectedProduct,
    id,
    locale,
  }) => {
    const { origin, hash, search, pathname } = window.location;
    const queryParams = {
      ...queryString.parse(search),
      recipeID,
    };
    const url =
      origin + pathname + "?" + queryString.stringify(queryParams) + hash;

    return axios({
      url: process.env.REACT_APP_SHARE_RECIPE_URL,
      method: "POST",
      params: { company_id: process.env.REACT_APP_KLAVIYO_PUBLIC_KEY },
      cancelToken: source.token,
      headers: {
        accept: "application/json",
        revision: "2024-05-15",
        "content-type": "application/json",
      },
      data: {
        data: {
          type: "event",
          attributes: {
            properties: {
              value: cost,
              message: url,
              finalImage: final_image,
              userChoices: userChoiceValuesForUI,
              expectedDelivery,
              selectedProductName: selectedProduct.name,
              productID: id,
              locale,
            },
            metric: {
              data: {
                type: "metric",
                attributes: { name: "Share MyBauer" },
              },
            },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: value,
                },
              },
            },
          },
        },
      },
    });
  };
}
